<template>
  <div class="col-sm-6 text-start">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Always Visible Scroll</h3>
      </div>
      <div class="card-body">
        <div class="scroll-bar-wrap ">
          <perfect-scrollbar class="visible-scroll always-visible scroll-demo" v-once :settings="settings5">
            <div>
              <div class="horz-scroll-content">
                <div class="row">
                  <div class="col-sm-6" v-for="item in data" :key="item">
                    <p>{{ item.desc }}</p>
                    <p>{{ item.desc1 }}</p>
                    <p>{{ item.desc2 }}</p>
                  </div>

                </div>
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import scrollable from "@/data/scrollable"
export default {
  data() {
    return {
      settings5: {
        maxScrollbarLength: 60,
      },
      data: scrollable.alwaysVisible
    }
  }
}
</script>
<style scoped>
.ps {
  height: 300px;
}
</style>